var _rect, _circle, _circle2, _circle3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuTeamSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "#FAD797"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0608,
    cy: 10.1774,
    r: 7.17735,
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.94423,
    cy: 23.1774,
    r: 5.82265,
    fill: "#FCFCFC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.1774,
    cy: 23.1774,
    r: 5.82265,
    fill: "#FCFCFC"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#FAD797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTeamSelected);
export default __webpack_public_path__ + "static/media/menu-team-selected.07b0b571c9ee8cb1430ecea43c2b35bf.svg";
export { ForwardRef as ReactComponent };